export default "__VITE_ASSET__Cqam61UL__"